import Icon from '../components/Icon.vue'

Icon.register({
  'pen-fancy': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M79.2 282.9l84.1-33.1 98.9 98.9-33.1 84.1c-2.8 8.4-11.9 17.4-20.2 20.2l-176.8 58.9-4.7-4.7 92.9-92.9c2.6 0.7 5 1.6 7.8 1.6 17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32c0 2.8 0.9 5.2 1.6 7.8l-92.9 92.9-4.7-4.7 58.9-176.8c2.8-8.4 11.9-17.4 20.2-20.2zM369.3 28.3c74.5-84.3 199.2 39.2 114.2 114.2l-199.5 183.1-97.9-97.9z'
      }
    ]
  }
})
